import { Component, signal, output, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { form, submit, required, email, maxLength, FormField } from '@angular/forms/signals';

export interface GuestFormData {
  email: string;
  lastname: string;
  firstname: string;
}

@Component({
  selector: 'mai-guest-disclaimer-form',
  imports: [FormField],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './guest-disclaimer-form.html',
})
export class GuestDisclaimerForm implements OnInit {
  readonly formData = input<GuestFormData>();
  readonly loading = signal(false);
  readonly formSubmitted = output<GuestFormData>();

  readonly guestModel = signal<GuestFormData>({
    email: '',
    lastname: '',
    firstname: '',
  });

  ngOnInit() {
    const guestData = this.formData();
    if (guestData) {
      this.guestModel.set(guestData);
    }
  }

  readonly guestForm = form(this.guestModel, (schema) => [
    required(schema.email, { message: 'Email is required' }),
    email(schema.email, { message: 'Please enter a valid email address' }),
    required(schema.lastname, { message: 'Last name is required' }),
    maxLength(schema.lastname, 50, { message: 'Last name must not exceed 50 characters' }),
    required(schema.firstname, { message: 'First name is required' }),
    maxLength(schema.firstname, 50, { message: 'First name must not exceed 50 characters' }),
  ]);

  /**
   * Submit the form (called by parent component)
   * The form data will be emitted to the parent for processing
   */
  submitForm(): void {
    submit(this.guestForm, async () => {
      this.loading.set(true);
      const formData = this.guestModel();
      this.formSubmitted.emit(formData);
    });
  }
}
